import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../components/ui/Header";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";

import CarListingTable from "./components/CarListingTable";
import CarListingForm from "./components/CarListingForm";
import CarListingViewModal from "./components/CarListingViewModal";
import DeleteConfirmModal from "../users-crud-management/components/DeleteConfirmModal";

import {
  getAllgovernoratesService,
  getCarBrandsService,
  getCarModelsService,
  getCarTypesService,
  getColorsService,
  getFuelTypesService,
  getgearTypeService,
  getImportingCountriesService,
} from "redux/services/general_service";

import { toast } from "react-toastify";
import {
  createListingsService,
  getListingsService,
  updateListingsService,
  deleteListingsService,
  getListingsByIdService,
} from "redux/services/listings_service";
import { getUsersService } from "redux/services/users_service";

const GalleryCrudMangment = () => {
  const dispatch = useDispatch();
  const { listinigList, metaListings } = useSelector((state) => state.listings);

  const [language, setLanguage] = useState("ar");
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);

  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [formMode, setFormMode] = useState("add");

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "ar";
    setLanguage(savedLanguage);

    dispatch(getListingsService({ page, search: searchQuery }));
    dispatch(getAllgovernoratesService());

    //
    dispatch(getAllgovernoratesService());
    dispatch(getColorsService());
    dispatch(getFuelTypesService());
    dispatch(getgearTypeService());
    dispatch(getCarBrandsService());
    dispatch(getCarTypesService());
    dispatch(getImportingCountriesService());
    dispatch(getCarModelsService());
    

    //users
        dispatch(getUsersService());
  }, [dispatch, page, searchQuery]);

  const labels = {
    title: { ar: "إدارة المعرض", en: "Gallery Management" },
    add: { ar: "إضافة معرض", en: "Add Gallery" },
    search: { ar: "البحث عن معرض...", en: "Search gallery..." },
  };
  console.log(listinigList);
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="container mx-auto px-4 py-6">
        {/* Title */}
        <div className="mb-8">
          <h1 className="text-3xl font-semibold">{labels.title[language]}</h1>
        </div>

        {/* Search & Actions */}
        <div className="bg-card rounded-xl p-6 shadow border border-border mb-8">
          <div className="flex flex-col lg:flex-row gap-4 justify-between">
            <Input
              placeholder={labels.search[language]}
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                dispatch(getListingsService({ search: e.target.value }));
                setPage(1);
              }}
              className="lg:max-w-md"
            />

            <Button
              variant="default"
              iconName="Plus"
              onClick={() => {
                setFormMode("add");
                setSelectedWorkshop(null);
                setIsFormModalOpen(true);
              }}
            >
              {labels.add[language]}
            </Button>
          </div>
        </div>

        {/* Table */}
        <CarListingTable
          listings={listinigList}
          metaListings={metaListings}
          language={language}
          onPageChange={(p) => setPage(p)}
          onView={(w) => {
            setSelectedWorkshop(w);
            dispatch(getListingsByIdService(w?.id));
            setIsViewModalOpen(true);
          }}
          onEdit={(w) => {
            setSelectedWorkshop(w);
            setFormMode("edit");
            setIsFormModalOpen(true);
          }}
          onDelete={(w) => {
            setSelectedWorkshop(w);
            setIsDeleteModalOpen(true);
          }}
        />

        {/* Form Modal */}
        {isFormModalOpen && (
          <CarListingForm
            isOpen
            listing={selectedWorkshop}
            mode={formMode}
            language={language}
            onClose={() => setIsFormModalOpen(false)}
            onSave={(data) => {
              if (formMode === "add") {
                dispatch(createListingsService(data)).then((response) => {
                  if (
                    response?.payload?.status === 200 ||
                    response?.payload?.status === 201
                  ) {
                    toast.success("تمت عملية الإضافة بنجاح!");
                    dispatch(getListingsService({ page }));
                    setIsFormModalOpen(false);
                  } else {
                    Object.values(response.payload.response?.data?.errors)
                      .flatMap((errorArray) => errorArray)
                      .forEach((error) => toast.warn(error));
                  }
                });
              } else {
                dispatch(
                  updateListingsService({
                    id: selectedWorkshop.id,
                    formData: data,
                  }),
                ).then((response) => {
                  if (
                    response?.payload?.status === 200 ||
                    response?.payload?.status === 201
                  ) {
                    toast.success("تم التحديث بنجاح!");
                    dispatch(getListingsService({ page }));
                    setIsFormModalOpen(false);
                  } else {
                    Object.values(response.payload.response?.data?.errors)
                      .flatMap((errorArray) => errorArray)
                      .forEach((error) => toast.warn(error));
                  }
                });
              }
            }}
          />
        )}

        {/* View Modal */}
        {isViewModalOpen && (
          <CarListingViewModal
            isOpen
            listing={selectedWorkshop} // بدل workshop
            language={language}
            onClose={() => setIsViewModalOpen(false)}
            onEdit={() => {
              setIsViewModalOpen(false);
              setFormMode("edit");
              setIsFormModalOpen(true);
            }}
            onDelete={() => {
              setIsViewModalOpen(false);
              setIsDeleteModalOpen(true);
            }}
          />
        )}

        {/* Delete Modal */}
        {isDeleteModalOpen && (
          <DeleteConfirmModal
            isOpen
            itemName={selectedWorkshop?.name}
            language={language}
            onClose={() => setIsDeleteModalOpen(false)}
            onConfirm={() => {
              dispatch(deleteListingsService(selectedWorkshop.id)).then(() => {
                toast("تم الحذف بنجاح");
                setIsDeleteModalOpen(false);
                dispatch(getListingsService({ page }));
              });
            }}
          />
        )}
      </main>
    </div>
  );
};

export default GalleryCrudMangment;
